import { createAction, PayloadAction } from '@reduxjs/toolkit';

import { AccordionsSearchState } from './types';

// SELECTORS
export const searchStringSelector = (state: AccordionsSearchState): string => state.searchString;
export const activeViewSelector = (state: AccordionsSearchState): string => state.activeView;

// ACTIONS
export enum AccordionsSearchReduxActions {
  SET_SEARCH_STRING = 'setSearchString',
  SET_ACTIVE_VIEW = 'setActiveView',
}

export const setSearchString = createAction<string>(AccordionsSearchReduxActions.SET_SEARCH_STRING);
export const setSearchStringActionHandler = (state: AccordionsSearchState, action: PayloadAction<string>): void => {
  state.searchString = action.payload;
};

export const setActiveView = createAction<string>(AccordionsSearchReduxActions.SET_ACTIVE_VIEW);
export const setActiveViewActionHandler = (state: AccordionsSearchState, action: PayloadAction<string>): void => {
  state.activeView = action.payload;
};
